module.exports = __webpack_public_path__ + "static/media/logo-cia-novo-roxo.db58252b.png";